import { render, staticRenderFns } from "./EditReason.vue?vue&type=template&id=0e7204ee&"
import script from "./EditReason.vue?vue&type=script&lang=js&"
export * from "./EditReason.vue?vue&type=script&lang=js&"
import style0 from "./EditReason.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports